import React, { useState, useEffect } from 'react';
import { Container, Navbar, Nav, Button, Dropdown, Image } from 'react-bootstrap';
import styles from './../style/Header.module.scss';

import FavoriteIcon from '../icons/FavoriteIcon'
import CartIcon from '../icons/CartIcon'

import FeedbackForm from './FeedbackForm';
import PhoneDropdown from './PhoneDropdown';
import SearchContainer from './SearchContainer';

const Header = ({ cart, favorite, options, menu, catalog, changeSearch, changeTopSearch, user_profile_type, authorized, showMobileMenu }) => {
  const adreses = 'sity' in options ? [options.sity] : [];
  const worktime = 'worktime' in options ? options.worktime : { one: '', two: '', opt: '' };
  
  const cartCount = cart.reduce((total, item) => total + item.count, 0);

  const [isCatalogDropdownOpen, setIsCatalogDropdownOpen] = useState(false);
  const [show_feedback, set_feedback] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [submenuTimeout, setSubmenuTimeout] = useState(null);

  const [scrolled, setScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleCatalogDropdown = () => {
    setIsCatalogDropdownOpen(!isCatalogDropdownOpen);
    if (isCatalogDropdownOpen) {
      setActiveSubmenu(null);
    }
  };

  const close_feedback = () => {
    set_feedback(false);
  };

  const handleItemMouseEnter = (child) => {
    if (submenuTimeout) {
      clearTimeout(submenuTimeout);
      setSubmenuTimeout(null);
    }
    setActiveSubmenu(child);
  };

  const handleMenuMouseLeave = () => {
    const timeout = setTimeout(() => {
      setActiveSubmenu(null);
    }, 300);
    setSubmenuTimeout(timeout);
  };

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          
          if (currentScrollY > 100) {
            setScrolled(currentScrollY > lastScrollY);
          } else {
            setScrolled(false);
          }
          
          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navbarClass = `${styles.navbar} ${scrolled ? styles.navbarHidden : ''}`;

  return (
    <>
    <div className={styles.header_fixed_pc}>
      {/* Top contact row */}
      <header className={styles.header}>
        <Container className={styles.container}>
          <div className={styles.topRow}>
            <a className={styles.logo} href="/">
              <Image alt="stomahelp.pro" src={options?.logo || ''} width="115" height="25" />
            </a>

            {/* Addresses */}
            <div className="d-none d-md-flex align-items-center">
              {adreses.map((elm, key) => (
                <div key={key} className={styles.addressBlock}>
                  <Image alt="Адрес" className="me-2" src="/images/adres.svg" width="17" height="17" />
                  <div>
                    <span className={styles.addressText}>
                      {elm}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.sep} />

            {/* Navigation menu */}
            <Nav className={styles.navBar}>
              {menu.map((item, key) => (
                <Nav.Link key={key} as="a" href={item.link} className={item.is_current == 2 ? styles.navLinkActive : styles.navLink}>{item.pagetitle}</Nav.Link>
              ))}
            </Nav>

            <div className={styles.sep} />

            {/* Working hours */}
            <div className={styles.workTimeBlock}>
              <Image alt="Время" className="me-2" src="/images/worktime.svg" width="16" height="16" />
              <div>
                <div className={styles.workTimeText}>
                  {worktime.one}
                </div>
                <div className={styles.workTimeSubtext}>
                  {user_profile_type == `legal` ? worktime.opt : worktime.two}
                </div>
              </div>
            </div>

            <div className={styles.sep} />

            <div className={styles.topRowEndMob}>
              {/* TG */}
              {'tglink' in options &&
                <a href={options.tglink} target="_blank" rel="noopener noreferrer">
                  <Image alt="TG" src={options?.tgicon || ''} width="30" height="30" />
                </a>
              }
              {/* WA */}
              {'walink' in options &&
                <a href={options.walink} target="_blank" rel="noopener noreferrer">
                  <Image alt="WA" src={options?.waicon || ''} width="30" height="30" />
                </a>
              }
            </div>

            {/* Телефон с выпадающим меню */}
            <PhoneDropdown options={options} userProfileType={user_profile_type} />

            <div className={styles.topRowEnd}>
              {/* TG */}
              {'tglink' in options &&
                <a href={options.tglink} target="_blank" rel="noopener noreferrer">
                  <Image alt="TG" src={options?.tgicon || ''} width="35" height="35" />
                </a>
              }
              {/* WA */}
              {'walink' in options &&
                <a href={options.walink} target="_blank" rel="noopener noreferrer">
                  <Image alt="WA" src={options?.waicon || ''} width="35" height="35" />
                </a>
              }

              <Button onClick={() => set_feedback(true)} className='text-white d-none d-xl-block' variant='primary'>Связаться</Button>

              <FeedbackForm
                title={`Нужна консультация?`}
                text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                btn={`Отправить`}
                data={[]}
                show={show_feedback}
                handleClose={() => close_feedback()}
              />
            </div>

          </div>
        </Container>
      </header>

      {/* Bottom navigation row */}
      <Navbar className={navbarClass}>
        <Container className={styles.container}>
          <a className={styles.logo} href="/">
            <Image alt="stomahelp.pro" src={options?.logo || ''} width="150" height="33" />
            <div>{options?.slogan || ''}</div>
          </a>

          {/* Catalog dropdown */}
          {user_profile_type != `legal` &&
            <Dropdown 
              show={isCatalogDropdownOpen}
              onToggle={toggleCatalogDropdown}
              className={styles.catalogDropdown}
            >
              <Dropdown.Toggle 
                as={Button} 
                variant="primary" 
                className={styles.catalogButton}
              >
                <Image alt="Кат" className="me-2" src="/images/catalog2.svg" width="17" height="11" />
                Каталог
              </Dropdown.Toggle>

              <Dropdown.Menu 
                className={styles.catalogMenu}
                onMouseLeave={handleMenuMouseLeave}
              >
                <div className={styles.catalogMenuContainer}>
                  <div className={styles.catalogMainMenu}>
                    {catalog.map((item, index) => (
                      <Dropdown.Item 
                        key={index} 
                        className={`${styles.catalogItem} ${item.child ? styles.hasChildren : ''}`}
                        active={item.is_current}
                        as="a"
                        href={item.link}
                        onMouseEnter={() => item.child && handleItemMouseEnter(item.child)}
                      >
                        <span dangerouslySetInnerHTML={{__html: item.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                        {item.child && (
                          <svg className={styles.submenuArrow} width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L5 5L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </Dropdown.Item>
                    ))}
                  </div>
                  
                  {/* Submenu */}
                  {activeSubmenu && activeSubmenu.length > 0 && (
                    <div className={styles.catalogSubmenu}>
                      {activeSubmenu.map((subItem, subIndex) => (
                        <a
                          key={subIndex}
                          href={subItem.link}
                          className={`${styles.catalogItem} ${styles.catalogSubitem}`}
                        >
                          <span dangerouslySetInnerHTML={{__html: subItem.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          }

          {/* Icons row mob */}
          <div className={styles.iconsRowMob}>
            <a href={options?.link_cart || '/'} className={styles.iconsRowMobEl + ` ` + styles.iconsRowMobElCart}>
              <div className={styles.iconsRowMobElIcon}>
                <CartIcon />
              </div>
              <div className={styles.iconLabel}>Корзина</div>
              {cartCount > 0 && (
                <span className={styles.cartCount}>
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </a>
            <div onClick={changeTopSearch} className={styles.iconsRowMobEl}>
              <svg style={{ color: '#000', width: '18px', height: '18px' }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.22448 15.2824C12.5702 15.2824 15.2824 12.5702 15.2824 9.22448C15.2824 5.87875 12.5702 3.1665 9.22448 3.1665C5.87875 3.1665 3.1665 5.87875 3.1665 9.22448C3.1665 12.5702 5.87875 15.2824 9.22448 15.2824Z" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.8333 15.8333L14.1812 14.1812" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div onClick={() => showMobileMenu()} className={styles.iconsRowMobEl}>
              <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.35 8.33333H0.85C0.624566 8.33333 0.408365 8.42113 0.248959 8.57741C0.0895533 8.73369 0 8.94565 0 9.16667C0 9.38768 0.0895533 9.59964 0.248959 9.75592C0.408365 9.9122 0.624566 10 0.85 10H9.35C9.57543 10 9.79164 9.9122 9.95104 9.75592C10.1104 9.59964 10.2 9.38768 10.2 9.16667C10.2 8.94565 10.1104 8.73369 9.95104 8.57741C9.79164 8.42113 9.57543 8.33333 9.35 8.33333ZM0.85 1.66667H16.15C16.3754 1.66667 16.5916 1.57887 16.751 1.42259C16.9104 1.26631 17 1.05435 17 0.833333C17 0.61232 16.9104 0.400358 16.751 0.244078C16.5916 0.0877975 16.3754 0 16.15 0H0.85C0.624566 0 0.408365 0.0877975 0.248959 0.244078C0.0895533 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0895533 1.26631 0.248959 1.42259C0.408365 1.57887 0.624566 1.66667 0.85 1.66667ZM16.15 4.16667H0.85C0.624566 4.16667 0.408365 4.25446 0.248959 4.41074C0.0895533 4.56702 0 4.77899 0 5C0 5.22101 0.0895533 5.43297 0.248959 5.58926C0.408365 5.74554 0.624566 5.83333 0.85 5.83333H16.15C16.3754 5.83333 16.5916 5.74554 16.751 5.58926C16.9104 5.43297 17 5.22101 17 5C17 4.77899 16.9104 4.56702 16.751 4.41074C16.5916 4.25446 16.3754 4.16667 16.15 4.16667Z" fill="black"/>
              </svg>
            </div>
          </div>

          {/* Search */}
          <SearchContainer 
            onChange={changeSearch} 
            onSearch={changeTopSearch} 
          />

          {/* Icons row */}
          <div className={styles.iconsRow}>
            {/* Favorite */}
            <a href={options?.link_favorite || '/'} className={styles.iconItem}>
              <FavoriteIcon isFavorite={favorite.length > 0} />
              <span className={styles.iconLabel}>Избранное</span>
            </a>

            {/* Cart */}
            <a href={options?.link_cart || '/'} className={styles.iconItem}>
              <div className={styles.cartContainer}>
                <CartIcon />
              </div>
              <span className={styles.iconLabel}>Корзина</span>
              {cartCount > 0 && (
                <span className={styles.cartCount}>
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </a>

            {/* Login */}
            <a href={options?.link_lk || '/'} className={styles.iconItem}>
              <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.08509 9.05242C9.03551 9.04534 8.97176 9.04534 8.91509 9.05242C7.66842 9.00992 6.67676 7.98993 6.67676 6.73618C6.67676 5.45409 7.71092 4.41284 9.00009 4.41284C10.2822 4.41284 11.3234 5.45409 11.3234 6.73618C11.3163 7.98993 10.3318 9.00992 9.08509 9.05242Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.7739 13.7275C12.5131 14.8821 10.8414 15.5833 8.99975 15.5833C7.15809 15.5833 5.48642 14.8821 4.22559 13.7275C4.29642 13.0616 4.72142 12.41 5.47934 11.9C7.42017 10.6108 10.5935 10.6108 12.5202 11.9C13.2781 12.41 13.7031 13.0616 13.7739 13.7275Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.00033 15.5834C12.9123 15.5834 16.0837 12.4121 16.0837 8.50008C16.0837 4.58806 12.9123 1.41675 9.00033 1.41675C5.08831 1.41675 1.91699 4.58806 1.91699 8.50008C1.91699 12.4121 5.08831 15.5834 9.00033 15.5834Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className={styles.iconLabel}>{authorized ? `Профиль` : `Войти`}</span>
            </a>
          </div>
        </Container>
      </Navbar>

      {/*<div id="specialButton" className={styles.specialButton}>
        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.625 20.5C25.625 21.8592 25.085 23.1628 24.1239 24.1239C23.1628 25.085 21.8592 25.625 20.5 25.625C19.1408 25.625 17.8372 25.085 16.8761 24.1239C15.915 23.1628 15.375 21.8592 15.375 20.5C15.375 19.1408 15.915 17.8372 16.8761 16.8761C17.8372 15.915 19.1408 15.375 20.5 15.375C21.8592 15.375 23.1628 15.915 24.1239 16.8761C25.085 17.8372 25.625 19.1408 25.625 20.5Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3.41699 20.5003C6.15033 13.5013 12.5327 8.54199 20.5003 8.54199C28.468 8.54199 34.8503 13.5013 37.5837 20.5003C34.8503 27.4994 28.468 32.4587 20.5003 32.4587C12.5327 32.4587 6.15033 27.4994 3.41699 20.5003Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>*/}

      <div className={styles.mobPodmena}></div>
    </div>
    <div className={styles.header_fixed_pc_zamena} />
    </>
  );
};

export default Header;